import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { CHATBOT_CONTEXT_IDS } from '../constants/chatbot-contexts';
import { ChatbotContextService } from './chatbot-context';

const PAGE_CONTEXT_CLEANUP: Record<string, string> = {
    'listing-details': CHATBOT_CONTEXT_IDS.LISTING_DETAILS,
};

@Injectable({
    providedIn: 'root',
})
export class ChatbotNavigationContextService {
    private readonly router = inject(Router);
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly contextService = inject(ChatbotContextService);

    private previousPageKey = '';

    initialize(): void {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.updateNavigationContext();
            });

        this.updateNavigationContext();
    }

    private updateNavigationContext(): void {
        const pageTitle = this.getPageTitle();
        const pageKey = this.getPageKey();

        if (this.previousPageKey && this.previousPageKey !== pageKey) {
            const contextIdToRemove = PAGE_CONTEXT_CLEANUP[this.previousPageKey];

            if (contextIdToRemove) {
                this.contextService.remove(contextIdToRemove);
            }
        }

        this.previousPageKey = pageKey;

        this.contextService.set(
            CHATBOT_CONTEXT_IDS.NAVIGATION_PAGE,
            'Page',
            `User is currently on the ${pageTitle} page`,
            {
                key: pageKey
            }
        );
    }

    private getPageTitle(): string {
        let route = this.activatedRoute;

        while (route.firstChild) {
            route = route.firstChild;
        }

        return (route.snapshot.data['pageTitle'] as string | null) ?? 'Unknown';
    }

    private getPageKey(): string {
        let route = this.activatedRoute;

        while (route.firstChild) {
            route = route.firstChild;
        }

        const key = (route.snapshot.data['key'] as string | null) ?? 'Unknown';

        return key.replace('prnyc-', '');
    }
}
